import { render, staticRenderFns } from "./ProductsWithCategory.vue?vue&type=template&id=3a604f88&"
import script from "./ProductsWithCategory.vue?vue&type=script&lang=js&"
export * from "./ProductsWithCategory.vue?vue&type=script&lang=js&"
import style0 from "./ProductsWithCategory.vue?vue&type=style&index=0&id=3a604f88&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports